import ApiServiceCustom from "../services/ApiServiceCustom";
import { convertDate, convertDateIso } from "../helpers/convertDate";

const ensinoList = async () => {
  return ApiServiceCustom.get({
    defaultUrl: process.env.VUE_APP_INFORMACOES_ACADEMICAS_API,
    resource: "ensino",
    slug: "/listagem",
  })
    .then(({ data }) => {
      return data.dados.map((data) => {
        return {
          value: data.id,
          label: data.descricao,
          text: data.descricao,
        };
      });
    })
    .catch(() => {
      return [];
    });
};

const ensinoListPorEscolaID = async (id) => {
  return ApiServiceCustom.get({
    defaultUrl: process.env.VUE_APP_MATRICULA_API,
    resource: "ensino_escola",
    slug: "/" + id + "/listagem",
  })
    .then(({ data }) => {
      return data.dados.map((data) => {
        return {
          value: data.id,
          label: data.descricao,
        };
      });
    })
    .catch(() => {
      return [];
    });
};

const ensinoListPorEscolaReordenamento = async (id) => {
  return ApiServiceCustom.get({
    defaultUrl: process.env.VUE_APP_MATRICULA_API,
    resource: "ensino_escola",
    slug: "/" + id + "/listagem/reordenamento",
  })
    .then(({ data }) => {
      return data.dados.map((data) => {
        return {
          value: data.id,
          label: data.descricao,
        };
      });
    })
    .catch(() => {
      return [];
    });
};

const ensinoRedeList = async () => {
  return ApiServiceCustom.get({
    defaultUrl: process.env.VUE_APP_MATRICULA_API,
    resource: "equivalencia_ensino_extra_rede",
    slug: "",
  })
    .then(({ data }) => {
      const dados = Array.isArray(data.dados)
        ? data.dados
        : Object.values(data.dados);

      return dados.map((item) => ({
        value: item.id,
        label: item.ensino_extra_rede,
        text: item.ensino_extra_rede,
      }));
    })
    .catch(() => {
      return [];
    });
};

const listarFiltros = async () => {
  return ApiServiceCustom.get({
    defaultUrl: process.env.VUE_APP_MATRICULA_API,
    resource: "equivalencia_ensino_extra_rede/filtros",
    slug: "",
  })
    .then(({ data }) => {
      const dados = Array.isArray(data.dados)
        ? data.dados
        : Object.values(data.dados);

      return dados;
    })
    .catch(() => {
      return [];
    });
};

const ensinoEquivalente = async (
  redeEnsino,
  faseId,
  ensinoDestinoId,
  municipioId
) => {
  let slug = "/" + redeEnsino + "/" + faseId + "/" + ensinoDestinoId;

  if (
    municipioId != null &&
    municipioId != undefined &&
    Number(redeEnsino) === 3
  )
    slug += "/" + municipioId;

  return ApiServiceCustom.get({
    defaultUrl: process.env.VUE_APP_MATRICULA_API,
    resource: "equivalencia_ensino/listagem",
    slug: slug,
  })
    .then(({ data }) => {
      return data.dados.map((data) => {
        return {
          value: data.id,
          label: data.fase,
        };
      });
    })
    .catch(() => {
      return [];
    });
};

const ensinosEquivalentes = async (
  redeEnsino,
  faseId,
  anoEscolaridade,
  indicadorAvanco,
  dataNascto,
  municipioId
) => {
  let dataFormatada = dataNascto as string;
  const numericRegex = /^\d+$/;
  if (typeof dataNascto === "number") {
    dataFormatada = convertDate(dataNascto);
  } else if (typeof dataNascto === "string" && numericRegex.test(dataNascto)) {
    dataFormatada = convertDate(Number(dataNascto));
  } else if (typeof dataNascto === "string") {
    dataFormatada = convertDateIso(dataNascto);
  }

  let slug =
    "/" +
    Number(redeEnsino) +
    "/" +
    Number(faseId) +
    "/" +
    Number(anoEscolaridade) +
    "/" +
    Number(indicadorAvanco) +
    "/" +
    dataFormatada;

  if (
    municipioId != null &&
    municipioId != undefined &&
    Number(redeEnsino) === 3
  )
    slug += "/" + Number(municipioId);

  return ApiServiceCustom.get({
    defaultUrl: process.env.VUE_APP_MATRICULA_API,
    resource: "equivalencia_ensino/ensino",
    slug: slug,
  })
    .then(({ data }) => {
      const dados = Array.isArray(data.dados)
        ? data.dados
        : Object.values(data.dados);

      return dados.map((item: any) => {
        const id = item.id ?? item.ensino_id ?? item.ensino_destino_id;
        const descricao =
          item.descricao ?? item.ensino ?? item.ensino_destino_descricao;
        return {
          value: id,
          label: descricao,
          text: descricao,
        };
      });
    })
    .catch(() => {
      return [];
    });
};

const ensinoPorID = async (id: number | string) => {
  const ensinoId = Number(id);
  if (!ensinoId) return [];
  return ApiServiceCustom.get({
    defaultUrl: process.env.VUE_APP_INFORMACOES_ACADEMICAS_API,
    resource: "ensino",
    slug: "/" + ensinoId,
  })
    .then(({ data }) => {
      return data.dados ?? null;
    })
    .catch(() => {
      return [];
    });
};

export {
  ensinoList,
  ensinoListPorEscolaID,
  ensinoRedeList,
  ensinoListPorEscolaReordenamento,
  listarFiltros,
  ensinoEquivalente,
  ensinosEquivalentes,
  ensinoPorID,
};

const ensinosEquivalentesComFases = async (
  redeEnsino,
  faseId,
  anoEscolaridade,
  indicadorAvanco,
  dataNascto,
  municipioId
) => {
  let dataFormatada = dataNascto as string;
  const numericRegex = /^\d+$/;
  if (typeof dataNascto === "number") {
    dataFormatada = convertDate(dataNascto);
  } else if (typeof dataNascto === "string" && numericRegex.test(dataNascto)) {
    dataFormatada = convertDate(Number(dataNascto));
  } else if (typeof dataNascto === "string") {
    dataFormatada = convertDateIso(dataNascto);
  }

  let slug =
    "/" +
    Number(redeEnsino) +
    "/" +
    Number(faseId) +
    "/" +
    Number(anoEscolaridade) +
    "/" +
    Number(indicadorAvanco) +
    "/" +
    dataFormatada;

  if (
    municipioId != null &&
    municipioId != undefined &&
    Number(redeEnsino) === 3
  ) {
    slug += "/" + Number(municipioId);
  }

  return ApiServiceCustom.get({
    defaultUrl: process.env.VUE_APP_MATRICULA_API,
    resource: "equivalencia_ensino/ensino",
    slug,
  })
    .then(({ data }) => {
      const raw = data?.dados;

      const dados = Array.isArray(raw)
        ? raw
        : raw && typeof raw === "object"
        ? "ensino_id" in raw || "ensino_descricao" in raw || "fase_id" in raw
          ? [raw]
          : Object.values(raw)
        : [];

      const fasesPorEnsino: Record<
        number,
        Array<{ value: number; label: string; text?: string }>
      > = {};
      const ensinosMap = new Map<number, string>();
      dados.forEach((item: any) => {
        const ensinoId = Number(
          item.ensino_id ?? item.ensino_destino_id ?? item.id
        );
        const ensinoDesc = String(
          item.ensino_descricao ??
            item.ensino_destino_descricao ??
            item.descricao ??
            ""
        ).trim();

        if (!ensinoId || !ensinoDesc) return;

        if (!ensinosMap.has(ensinoId)) ensinosMap.set(ensinoId, ensinoDesc);

        const faseIdNum = Number(item.fase_id ?? item.fase_destino_id);
        const faseDesc = String(
          item.fase_descricao ?? item.fase_destino ?? item.fase ?? ""
        ).trim();

        if (!faseIdNum || !faseDesc) return;

        if (!fasesPorEnsino[ensinoId]) fasesPorEnsino[ensinoId] = [];

        if (!fasesPorEnsino[ensinoId].some((f) => f.value === faseIdNum)) {
          fasesPorEnsino[ensinoId].push({
            value: faseIdNum,
            label: faseDesc,
            text: faseDesc,
          });
        }
      });

      const ensinos = Array.from(ensinosMap.entries()).map(
        ([value, label]) => ({
          value,
          label,
          text: label,
        })
      );

      return { ensinos, fasesPorEnsino };
    })
    .catch(() => {
      return { ensinos: [], fasesPorEnsino: {} };
    });
};

export { ensinosEquivalentesComFases };
